/*
 * LocaleToggle Messages
 *
 * This contains all the text for the LanguageToggle component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  en: {
    id: 'boilerplate.containers.LocaleToggle.en',
    defaultMessage: 'English',
  },
  vi: {
    id: 'boilerplate.containers.LocaleToggle.vi',
    defaultMessage: 'Việt Nam',
  },
  fr: {
    id: 'boilerplate.containers.LocaleToggle.fr',
    defaultMessage: 'French',
  },
  es: {
    id: 'boilerplate.containers.LocaleToggle.es',
    defaultMessage: 'Spanish',
  },
});



// WEBPACK FOOTER //
// ./app/containers/LocaleToggle/messages.js